import React from "react"
import "./css/Header.css"
import "./css/Team.css"
import fiona from "../assets/fiona.jpg"
import grace from "../assets/grace.jpg"
import nashiyayo from "../assets/nashiyayo.jpg"
import enrich from "../assets/enrich.png"
import harambe from "../assets/harambe.png"
import amina from "../assets/amina.jpg"
import ole from "../assets/ole.jpg"
import lioga from "../assets/lioga.jpg"
import kepende from "../assets/kepende.jpg"
import samuel from "../assets/samuel.jpg"
import saitoti from "../assets/saitoti.jpg"
import avatar from "../assets/avatar.jpeg"

const Team = () => {
  const leadershipTeam = [
    {
      name: "Amina Hirsi",
      position: "CEO",
      profile: "A highly ambitious, passionate and competent Kenyan British, with strong academic & professional experience in training, education, entrepreneurship, and Environmental Sciences. Amina Hirsi has Master's degree in Green Economy from Bournemouth University, UK, and has 20+ years' experience in senior management & has held various leadership positions in several countries. She is a dynamic entrepreneur committed to supporting the role of women in business, and offers expert advice on Carbon Markets, Agro-Forestry and Bio-diversity conservation. Amina is often invited to speak at conferences, universities and on TV on climate change & environment. Amina is proficient in analysing and creating policies, research, advocacy, scoping studies, briefs, review papers, policies & constitutions, submissions and strategies. She offers high level consultancy services to governments, businesses and institutions.",
      image: amina,
      expertise: ["Green Economy", "Carbon Markets", "Policy Development", "Agro-Forestry"]
    },
    {
      name: "Fiona Crehan",
      position: "Strategic Director",
      profile: "Fiona grew-up in the Republic of Ireland, and is currently based in Kenya. She has a degree in architecture, and 20+ years' experience managing economic development programmes in local governments in London and other parts of the UK. Fi has developed economic strategies and community-based economic programmes, secured funding, managed delivery of business growth with successful audits and evaluation of results.",
      image: fiona,
      expertise: ["Architecture", "Economic Development", "Programme Management", "Strategy"]
    },
    {
      name: "Mohamoud Osman",
      position: "Finance Director",
      profile: "Mohamoud Osman has 22 years' experience in top financial management positions. His expertise lie in origination of new transactions, business development into new markets, stakeholder management & post transaction management.",
      image: avatar,
      expertise: ["Financial Management", "Business Development", "Stakeholder Management", "Transactions"]
    }
  ]
  
  const teamMembers = [
    {
      name: "Ole Singa'ru Parit",
      position: "Community Engagement Leader",
      image: ole
    },
    {
      name: "Grace Nadoba",
      position: "Programs Manager",
      image: grace
    },
    {
      name: "Nashiyayo Lorboi",
      position: "Community Liaison Officer",
      image: nashiyayo
    },
    {
      name: "Saitoti Naboro",
      position: "Nurseries Manager",
      image: saitoti
    },
    {
      name: "Lioga Kimili",
      position: "Security & Safety Manager",
      image: lioga
    },
    {
      name: "Kepende Masarie",
      position: "Youth Leader",
      image: kepende
    },
    {
      name: "Samuel Milaira",
      position: "Administrator",
      image: samuel
    }
  ]

  return (
    <div className="team-page">
      {/* Page Header */}
      <section className="page-header">
        <div className="container">
          <div className="header-content">
            <h1 className="page-title">Meet Our Team</h1>
            <p className="page-subtitle">
              A vibrant and diverse core team driving Africa's green revolution with expertise and passion
            </p>
          </div>
        </div>
      </section>

      {/* Team Overview */}
      <section className="team-overview-section">
        <div className="container">
          <div className="team-overview-content">
            <div className="overview-text">
              <h2 className="section-title">Our Team</h2>
              <div className="title-underline"></div>
              <p className="overview-description">
                We have a vibrant and diverse core team with a range of skills and expertise. Jambo Tree Kenya also has an operations team, backed by a huge pool of supporters, ambassadors and advisers. We also have a large network of seed collectors and affiliate tree nurseries across Kenya.
              </p>
            </div>
            
            <div className="team-stats">
              <div className="stat-item">
                <h3 className="stat-number">10+</h3>
                <p className="stat-label">Team Members</p>
              </div>
              <div className="stat-item">
                <h3 className="stat-number">50+</h3>
                <p className="stat-label">Years Combined Experience</p>
              </div>
              <div className="stat-item">
                <h3 className="stat-number">100%</h3>
                <p className="stat-label">Women-Led Initiative</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Leadership Team */}
      <section className="leadership-section">
        <div className="container">
          <h2 className="section-title">Leadership Team</h2>
          <div className="title-underline"></div>
          
          <div className="leadership-grid">
            {leadershipTeam.map((member, index) => (
              <div key={index} className="leadership-card">
                <div className="member-image-container">
                  <img src={member.image} alt={member.name} className="member-image" />
                </div>
                <div className="member-info">
                  <h3 className="member-name">{member.name}</h3>
                  <p className="member-position">{member.position}</p>
                  <p className="member-profile">{member.profile}</p>
                  <div className="expertise-tags">
                    {member.expertise.map((skill, skillIndex) => (
                      <span key={skillIndex} className="expertise-tag">{skill}</span>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Core Team */}
      <section className="core-team-section">
        <div className="container">
          <h2 className="section-title">Core Team Members</h2>
          <div className="title-underline"></div>
          
          <div className="team-grid">
            {teamMembers.map((member, index) => (
              <div key={index} className="team-member-card">
                <div className="member-photo">
                  <img src={member.image} alt={member.name} className="team-member-image" />
                </div>
                <div className="member-details">
                  <h3 className="member-name">{member.name}</h3>
                  <p className="member-position">{member.position}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Partnerships & Support */}
      <section className="partnerships-section">
        <div className="container">
          <h2 className="section-title">Our Partners & Supporters</h2>
          <div className="title-underline"></div>
          
          <div className="partnerships-content">
            <div className="partnership-text">
              <div className="partnership-item">
                <h4>Technology Partnership</h4>
                <p>
                  Jambo Tree Kenya is working in partnership with{" "}
                  <a href="https://enrichgeo.com/" target="_blank" rel="noopener noreferrer" className="partner-link">
                    EnrichGeo Technologies Solutions
                  </a>
                  , which uses innovation technology and expertise to assess land and soil characteristics and inform the selection of tree species and produce to grow that is suitable for land and climate.
                </p>
              </div>
              
              <div className="partnership-item">
                <h4>Government Support</h4>
                <p>
                  Jambo Tree Kenya is supported by Kenya Government Climate Change envoy.
                </p>
              </div>
              
              <div className="partnership-item">
                <h4>Photography Credits</h4>
                <p>
                  📸 Photos by{" "}
                  <a href="https://www.linkedin.com/company/kimrixphotography/" target="_blank" rel="noopener noreferrer" className="partner-link">
                    Kim Rix Photography
                  </a>
                </p>
              </div>
            </div>
            
            <div className="partner-logos">
              <div className="logo-item">
                <img src={enrich} alt="EnrichGeo Technologies Solutions" className="partner-logo" />
              </div>
              <div className="logo-item">
                <img src={harambe} alt="Kenya Government Climate Change" className="partner-logo" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="team-cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Join Our Mission</h2>
            <p>Interested in working with our expert team? Let's discuss how we can collaborate on your sustainability goals.</p>
            <div className="cta-buttons">
              <a href="/work-with-us" className="btn btn-primary">Work With Us</a>
              <a href="/contact" className="btn btn-outline">Contact Our Team</a>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Team